import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Payment, Order } from "../models/order";
import { Product } from "../models/product";
import * as _ from "lodash";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  private defultPayment: Payment = {
    paymentType: null,
    cardNumber: null,
    cardName: null,
    month: null,
    year: null,
    cvv: null,
  };
  private defultOrder: Order = {
    branch: null,
    orderType: null,
    firstName: null,
    lastName: null,
    state: null,
    deliveryFee: 0,
    sum: 0,
    diners:1,
    date: null,
    countItems: 0,
    address: null,
    city: null,
    street: null,
    homeNum: null,
    apartment: null,
    floor: null,
    email: null,
    country: null,
    items: [],
    cutlery:false,
    payment: this.defultPayment,
    response:null
  };

  private _order: Order = this.defultOrder;
  private order: BehaviorSubject<Order> = new BehaviorSubject(this._order);
  private _countItemsInCart: number = 0;
  private countItemsInCart: BehaviorSubject<number> = new BehaviorSubject(
    this._countItemsInCart
  );
  private _payment: Payment = this.defultPayment;
  constructor() {}

  public setOrder(order) {
    this._order = {
      branch: order.branch ? order.branch : this._order.branch,
      orderType: order.orderType ? order.orderType : this._order.orderType,
      firstName: order.firstName ? order.firstName : this._order.firstName,
      lastName: order.lastName ? order.lastName : this._order.lastName,
      state: order.state ? order.state : this._order.state,
      address: order.address ? order.address : this._order.address,
      city: order.city ? order.city : this._order.city,
      street: order.street ? order.street : this._order.street,
      apartment: order.apartment ? order.apartment : this._order.apartment,
      homeNum: order.homeNumber ? order.homeNumber : this._order.homeNum,
      floor: order.floor ? order.floor : this._order.floor,
      diners: order.diners ? order.diners : this._order.diners,
      remarks: !_.isNil(order.remarks) ? order.remarks : this._order.remarks,
      phone: order.phone ? order.phone : this._order.phone,
      deliveryFee: (order.deliveryFee || order.deliveryFee==0)
        ? order.deliveryFee
        : this._order.deliveryFee,
      sum: order.sum ? order.sum : this._order.sum,
      date: order.date ? order.date : this._order.date,
      items: order.items ? order.items : this._order.items,
      email: order.email ? order.email : this._order.email,
      country: order.country ? order.country : this._order.country,
      cutlery:order.cutlery ? order.cutlery : this._order.cutlery,
      payment: order.payment ? order.payment : this._order.payment,
      response :order.response ? order.response : this._order.response,
    };
    this.calulateSumItems();
    if (order.items){
      this.countItemsInCart.next(this._order.countItems);
    }
    this.order.next(this._order);
  }

  public removeOrder() {
    this._order=this.defultOrder;
    this.order.next(this._order);
  }

  public setPayment(payment) {
    this._payment = {
      paymentType: payment.paymentType
        ? payment.paymentType
        : this._payment.paymentType,
      cardNumber: payment.cardNumber
        ? payment.cardNumber
        : this._payment.cardNumber,
      cardName: payment.cardName ? payment.cardName : this._payment.cardName,
      month: payment.month ? payment.month : this._payment.month,
      year: payment.year ? payment.year : this._payment.year,
      cvv: payment.cvv ? payment.cvv : this._payment.cvv,
    };
    this.setOrder({ payment: this._payment });
  }

  public getOrder(): Observable<Order> {
    return this.order.asObservable();
  }

  public getOrderObject(): Order {
    return this._order;
  }

  public resetOrder() {
    this._order = this.defultOrder;
  }

  public getOrderItems(): Product[] {
    return this._order.items;
  }

  public setRemark(remark){
    this.setOrder({remraks:remark})
  }
  
  public calulateSumItems() {
    let sum = 0;
    let count = 0;
    _.each(this._order.items, (item: Product) => {
      count += item.productQuantity;
      sum += item.totalPrice;
    });
    this._order.countItems = count;
    this._order.sum = sum;
  }

  public getNumberItemsInCart(): Observable<number> {
    return this.countItemsInCart.asObservable();
  }
}
